'use strict';

module.exports = {
  template: require('./forgot-password.html'),
  controller: require('./forgot-password.controller.js'),
  controllerAs: 'vm'
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/forgot-password/index.js
 ** module id = 182
 ** module chunks = 0
 **/